import { twMerge } from 'tailwind-merge';

interface SpinnerProps {
  containerClassName?: string;
  spinnerClassName?: string;
}

export const Spinner = ({
  containerClassName,
  spinnerClassName,
}: SpinnerProps) => {
  return (
    <div
      className={twMerge(
        'absolute inset-0 flex justify-center items-center pointer-events-none z-40',
        containerClassName
      )}
    >
      <div
        className={twMerge(
          'w-8 min-w-8 h-8 min-h-8 border-2 border-white border-t-transparent rounded-full animate-spin',
          spinnerClassName
        )}
      >
        &nbsp;
      </div>
    </div>
  );
};
